import * as React from "react";

type SupportedLanguages = "RU" | "EN";

interface ILanguageSwitchButtonProps {
  currentLanguage?: SupportedLanguages;
  supportedLanguages?: SupportedLanguages[];
  onLanguageChange?: (lang: SupportedLanguages) => void;
}

const LanguageSwitchButton: React.FunctionComponent<
  ILanguageSwitchButtonProps
> = ({
  currentLanguage = "RU",
  supportedLanguages = ["RU", "EN"],
  onLanguageChange,
}) => {
  const languages: SupportedLanguages[] = [...supportedLanguages];

  const handleLanguageSwitch = () => {
    const currentIndex = languages.indexOf(currentLanguage);
    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLanguage = languages[nextIndex];
    onLanguageChange?.(nextLanguage);
  };

  return (
    <>
      {/* Language Switch Button */}
      <div className="flex items-center justify-center shrink-0 size-[60px]">
        <button
          onClick={handleLanguageSwitch}
          className="flex items-center justify-center rounded-[8px] size-[40px] hover:bg-gray-100 transition-colors"
        >
          <p className="font-['Hind',sans-serif] font-bold text-[18px] text-black">
            {currentLanguage}
          </p>
        </button>
      </div>
    </>
  );
};

export default LanguageSwitchButton;
export type { SupportedLanguages };
